import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Checkout2, ErrorPage } from "./pages";
import NewThankyouPage from "./pages/NewThankyouPage";
import PapAffiliateTracker from "./components/PapAffiliateTracker";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <PapAffiliateTracker />
        <Routes>
          <Route path="/" element={<Checkout2 />} />
          <Route path="/thankyou-page" element={<NewThankyouPage />} />
          <Route path="/ErrorPage" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
